module.exports = __webpack_public_path__ + "static/media/minus-sign-restaurant.14627e61.svg";